<section class="divider">
	<h2 class="secondary-header !mb-0">
		@if (!sectionTitle) {
			{{
				clearingEnabled
					? 'Courses Available in Clearing'
					: 'Quick Search Popular Courses'
			}}
		} @else {
			{{ sectionTitle }}
		}
	</h2>

	@if (showButton) {
		<div class="hidden md:block">
			<a
				routerLink="/courses/degrees"
				class="inline-flex items-center -mt-1 blue-button btn-py-2 focus:outline-none"
			>
				<uc-search-svg customStyles="mr-2" />
				Search Degrees
			</a>
		</div>
	}

	<uc-description
		[description]="sectionDesc ?? description"
		[charLimit]="110"
		[truncateMobileOnly]="true"
		[shortLength]="110"
		customPaddingTop="pt-4"
	/>

	<!-- options -->
	<div class="md:-mb-5 mt-7">
		<swiper-container #swiperRef init="false">
			@for (tile of tiles; track $index) {
				<swiper-slide>
					<div class="flex flex-col">
						@for (subject of tile; track $index; let last = $last) {
							<a
								[routerLink]="[
									'/courses',
									clearingEnabled ? 'clearing' : 'degrees',
									subject.searchTerm,
								]"
								class="py-4 text-left border-b md:border-b-0"
								[ngClass]="{ 'border-b': !last }"
							>
								<span
									class="block font-bold font-base hover:text-uc-blue-900 hover:transition-colors"
									>{{ subject.title }} Degrees</span
								>
								<span class="block text-sm text-gray-500"
									>{{ subject.courseAmt }} courses found</span
								>
							</a>
						}
					</div>
				</swiper-slide>
			}
		</swiper-container>
	</div>
</section>
